/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnUpLeftIcon20Light = forwardRef('ArrowDUturnUpLeftIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.516.628a.5.5 0 1 1 .669.744l-3.968 3.57A.76.76 0 0 0 4.16 5h6.34a6.5 6.5 0 0 1 0 13h-4a.5.5 0 1 1 0-1h4a5.5 5.5 0 1 0 0-11H4.16c.017.02.037.04.057.057l3.968 3.571a.5.5 0 0 1-.67.744L3.549 6.8a1.75 1.75 0 0 1 0-2.602L7.516.63Z" })));
});
